import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getTrolleyID } from "../actions/trolley";
import { authenticatedTrolleyList } from "../v2_actions/authenticated_trolley";

const useBeforeUnloadWarning = () => {
  // @ts-ignore
  const trolley_id = useSelector((state) => getTrolleyID(state));
  const trolley = useSelector(() => authenticatedTrolleyList.getObject(trolley_id));

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      const hasItems = trolley?.number_of_photos && trolley.number_of_photos > 0;

      if (hasItems) {
        e.preventDefault();
        e.returnValue = '';
        return '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [trolley]);
};

export default useBeforeUnloadWarning;
